import React from 'react';
import { Button, Text, Flex, ChatMessage } from 'pcln-design-system';
import { TravelBotLogoImage } from './TravelBotLogoImage';
import MessageFooter from './components/MessageFooter/MessageFooter';
/**
 * @public
 */
function SignInMarkerComponent(props) {
  const {
    signedIn,
    onSigninClick
  } = props;
  const onClickHandler = () => {
    var _a, _b;
    // @ts-ignore
    (_b = (_a = window.PCLN) === null || _a === void 0 ? void 0 : _a.pclnEventDispatcher) === null || _b === void 0 ? void 0 : _b.dispatch('GLOBAL_PCLN_LAUNCH_SIGNIN_MODAL');
  };
  return React.createElement(Flex, {
    mb: 3,
    flexDirection: 'column'
  }, React.createElement(ChatMessage, {
    variation: 'initial',
    Icon: TravelBotLogoImage,
    footer: React.createElement(MessageFooter, null),
    message: signedIn ? React.createElement(Text, {
      mb: 3,
      fontSize: 2
    }, "Looks like you're already signed in! You're welcome to ask additional questions if you have any!") : React.createElement(Flex, {
      flexDirection: 'column'
    }, React.createElement(Text, {
      mb: 3,
      fontSize: 2
    }, "Click the button below to Sign In."), React.createElement(Text, {
      fontSize: 2
    }, "To safeguard your privacy, this chat will be cleared upon signing in."))
  }), !signedIn && React.createElement(Flex, {
    ml: 3,
    mt: 3
  }, React.createElement(Button, {
    variation: 'subtle',
    onClick: onSigninClick || onClickHandler
  }, "Sign In")));
}
export { SignInMarkerComponent };